<template>
    <div class="row">
        <div class="col-md-12 col-sm-12">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item :to="{ path: '/' }"><i class="fa fa-home"></i></el-breadcrumb-item>
                <el-breadcrumb-item v-for="(item, index) in breadcrumbsItems" :key="`breadcrumb-item-${index}`" :to="item">
                    {{ $t(item.label) }}
                </el-breadcrumb-item>
                <el-breadcrumb-item v-if="label">
                    {{ $t(label) }}
                </el-breadcrumb-item>
            </el-breadcrumb>
        </div>
    </div>
</template>

<script>
  import { Breadcrumb, BreadcrumbItem } from 'element-ui'
  import TeamDropDown from '../Views/Team/TeamDropDownList'

  export default {
    name: 'Breadcrumb',
    props: {
      breadcrumbs: {
        type: Array,
        default: () => undefined
      },
      label: {
        type: String,
        default: () => undefined

      }
    },
    components: {
      [Breadcrumb.name]: Breadcrumb,
      [BreadcrumbItem.name]: BreadcrumbItem,
      TeamDropDown: TeamDropDown
    },
    computed: {
      breadcrumbsItems: function () {
        return this.$store.getters['breadcrumb/getByPath'](this.$route.path)
          || this.breadcrumbs
          || this.$route.meta.breadcrumb
      }
    }
  }
</script>
<style lang="scss">
    .el-breadcrumb {
        &__item {
            font-size: 1.5em;
            .el-breadcrumb__inner.is-link:hover {
                color: #0097ae !important;
            }
            &:last-child {
                .el-breadcrumb__inner.is-link:hover {
                    color: #606266 !important;
                }
            }
        }
        .el-breadcrumb__item {
          display: contents;
        }
    }
</style>
